export default function reducer(
  state = {
    creativeFileUpload: '',
  },
  action
) {
  switch (action.type) {
    case 'CREATIVE_FILE_UPLOAD_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'CREATIVE_FILE_UPLOAD_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        creativeFileUpload: action.payload,
      };
    }
    case 'CREATIVE_FILE_UPLOAD_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        creativeFileUpload: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
